import {
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";
import {
  HeaderRow,
  MaterialTable,
  MaterialTableContainer,
} from "components/core/BaseTable/styles";
import React, { useMemo } from "react";
import { formatDateReverse, getFileNameFromUrl } from "utlis/utils";
import { Link } from "./styles";
import { startCase } from "lodash";
import { Ptag } from "components/core";
import routes from "components/routes";
import { useNavigate } from "react-router";

const HEADERS = [
  "Batch Number",
  "Cut-Off Date",
  "Submission Date",
  "Total No. of Employees",
  "Employee Data",
  "Status",
];

const BatchTable = ({ enrolments, isGmcFlow }) => {
  const navigate = useNavigate();
  const goToPendingScreen = () => {
    const pageToShow = enrolments[0].page_to_show;
    const superTaskId = enrolments[0].id;
    console.log({ superTaskId });
    sessionStorage.setItem("flex_setup_type", "enrollment_history");
    localStorage.setItem("super_task_id", superTaskId);

    switch (pageToShow) {
      case "MASTER_FAILURE":
        navigate({
          pathname: `/${routes.FLEX_ERROR_FILE}`,
          state: { flow: "enrollment_history" },
        });
        break;
      case "CUTOFF_DATE_PENDING":
      case "MASTER_PENDING":
        navigate({
          pathname: `/${routes.FLEX_PENDING_STATE}`,
          state: { flow: "enrollment_history" },
        });
        break;
      case "PRODUCTS_NOT_ALL_SUCCESS":
      case "CUTOFF_DATE_INSERT":
        navigate({
          pathname: `/${routes.FLEX_PRODUCT_STATUS}`,
          state: { flow: "enrollment_history" },
        });
        break;
      case "PRODUCTS_INSERT":
        navigate({
          pathname: `/${routes.FLEX_PRODUCT_UPLOAD}`,
          state: { flow: "enrollment_history" },
        });
        break;
      case "ALL_SUCCESS":
        navigate({
          pathname: `/${routes.FLEX_DASHBOARD}`,
          state: { flow: "enrollment_history" },
        });
        break;
    }
  };

  const renderStatus = (status) => {
    if (status.toLowerCase() === "submission incomplete" && !isGmcFlow) {
      return (
        <Link onClick={goToPendingScreen}>
          {startCase(status.toLowerCase())}
        </Link>
      );
    }
    return (
      <Ptag style={{ display: "inline" }}>
        {startCase(status.toLowerCase())}
      </Ptag>
    );
  };

  const headers = useMemo(() => {
    if (isGmcFlow)
      return HEADERS.filter(
        (header) => !["Cut-Off Date", "Employee Data"].includes(header)
      );
    return HEADERS;
  }, [isGmcFlow]);

  return (
    <TableContainer sx={MaterialTableContainer}>
      <Table aria-label="simple table" sx={MaterialTable}>
        <TableHead>
          <TableRow>
            {headers.map((header, index) => (
              <TableCell
                key={index}
                variant="head"
                align="center"
                sx={HeaderRow}
              >
                {header}
              </TableCell>
            ))}
          </TableRow>
        </TableHead>
        <TableBody>
          {enrolments.map((enrolment, index) => (
            <TableRow
              key={enrolment.id}
              sx={{
                "&:last-child td, &:last-child th": { border: 0 },
              }}
            >
              <TableCell align="center" component="th" scope="row">
                <Ptag style={{ display: "inline" }}>{`Batch ${
                  enrolments.length - index
                }`}</Ptag>
              </TableCell>
              {!isGmcFlow && (
                <TableCell align="center">
                  <Ptag style={{ display: "inline" }}>
                    {formatDateReverse(enrolment.cutoff_date)}
                  </Ptag>
                </TableCell>
              )}
              <TableCell align="center">
                <Ptag style={{ display: "inline" }}>
                  {formatDateReverse(enrolment.submission_date)}
                </Ptag>
              </TableCell>
              <TableCell align="center">
                <Ptag style={{ display: "inline" }}>
                  {isGmcFlow
                    ? enrolment.employees_count
                    : enrolment.cutoff_date_marked_employees_count}
                </Ptag>
              </TableCell>
              {!isGmcFlow && (
                <TableCell align="center">
                  <Link href={enrolment.master_file_url}>
                    {getFileNameFromUrl(enrolment.master_file_url)}
                  </Link>
                </TableCell>
              )}
              <TableCell align="center">
                {renderStatus(enrolment.enrollment_history_screen_status)}
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default BatchTable;
